import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import GeneralRiskDefinitionsTable from './framework/definitions/GeneralRiskDefinitionsTable';
import GeneralRiskImpactCategoriesTab from './framework/impact_categories/GeneralRiskImpactCategoriesTab';
import GeneralRiskImpactsTable from './framework/impacts/GeneralRiskImpactsTable';
import GeneralRiskProbabilitiesTable from './framework/probabilities/GeneralRiskProbabilitiesTable';
import GeneralRiskStatusesTab from './framework/statuses/GeneralRiskStatusesTab';
import GeneralRiskTypesTab from './framework/types/GeneralRiskTypesTab';

const queryParams = new URLSearchParams(window.location.search);
const query = { tab: queryParams.get('tab') };

export default function GeneralRiskFramework(props) {
    useEffect(() => {
        if (query.tab === 'types') {
            $('#risk_type_tab').tab('show');
        } else if (query.tab === 'impact_categories') {
            $('#impact_category_tab').tab('show');
        } else if (query.tab === 'statuses') {
            $('#status_tab').tab('show');
        }
    }, []);

    const onCategoryClick = (id) => {
        $(`#${id}_tab`).tab('show');
    };

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-6">
                <div
                    className="in-nav horizontal"
                    data-tabs-active-classes="active"
                    data-tabs-inactive-classes="inactive"
                    data-default-tab-id="general-risk-overview-tab"
                    data-tabs-toggle="#general-risk-framework-tab-content"
                    role="tablist"
                >
                    <button
                        className="in-nav__item"
                        id="general-risk-overview-tab"
                        data-tabs-target="#general-risk-overview"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-overview"
                        aria-selected="true"
                    >
                        {$t('Overview')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="general-risk-types-tab"
                        data-tabs-target="#general-risk-types"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-types"
                        aria-selected="false"
                    >
                        {$t('Types')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="general-risk-impacts-tab"
                        data-tabs-target="#general-risk-impacts"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-impacts"
                        aria-selected="false"
                    >
                        {$t('Impact')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="general-risk-impact-categories-tab"
                        data-tabs-target="#general-risk-impact-categories"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-impact-categories"
                        aria-selected="false"
                    >
                        {$t('Impact Category')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="general-risk-probabilities-tab"
                        data-tabs-target="#general-risk-probabilities"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-probabilities"
                        aria-selected="false"
                    >
                        {$t('Probability')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="general-risk-statuses-tab"
                        data-tabs-target="#general-risk-statuses"
                        type="button"
                        role="tab"
                        aria-controls="general-risk-statuses"
                        aria-selected="false"
                    >
                        {$t('Status')}
                    </button>
                </div>

                <div id="general-risk-framework-tab-content">
                    <div id="general-risk-overview" role="tabpanel" aria-labelledby="general-risk-overview-tab">
                        <GeneralRiskDefinitionsTable
                            fetchUrl={fetchGeneralRiskDefinitionsUrl}
                            updateUrl={updateGeneralRiskDefinitionUrl}
                            onCategoryClick={onCategoryClick}
                        />
                    </div>
                    <div id="general-risk-types" role="tabpanel" aria-labelledby="general-risk-types-tab">
                        <GeneralRiskTypesTab
                            fetchUrl={fetchGeneralRiskTypesUrl}
                            storeUrl={storeGeneralRiskTypesUrl}
                            updateUrl={updateGeneralRiskTypesUrl}
                            deleteUrl={deleteGeneralRiskTypesUrl}
                        />
                    </div>
                    <div id="general-risk-impacts" role="tabpanel" aria-labelledby="general-risk-impacts-tab">
                        <GeneralRiskImpactsTable fetchUrl={fetchGeneralRiskImpactsUrl} updateUrl={updateGeneralRiskImpactUrl} />
                    </div>
                    <div id="general-risk-impact-categories" role="tabpanel" aria-labelledby="general-risk-impact-categories-tab">
                        <GeneralRiskImpactCategoriesTab
                            fetchUrl={fetchGeneralRiskImpactCategoriesUrl}
                            storeUrl={storeGeneralRiskImpactCategoriesUrl}
                            updateUrl={updateGeneralRiskImpactCategoriesUrl}
                            deleteUrl={deleteGeneralRiskImpactCategoriesUrl}
                        />
                    </div>
                    <div id="general-risk-probabilities" role="tabpanel" aria-labelledby="general-risk-probabilities-tab">
                        <GeneralRiskProbabilitiesTable fetchUrl={fetchGeneralRiskProbabilitiesUrl} updateUrl={updateGeneralRiskProbabilityUrl} />
                    </div>
                    <div id="general-risk-statuses" role="tabpanel" aria-labelledby="general-risk-statuses-tab">
                        <GeneralRiskStatusesTab
                            fetchUrl={fetchGeneralRiskStatusesUrl}
                            storeUrl={storeGeneralRiskStatusesUrl}
                            updateUrl={updateGeneralRiskStatusesUrl}
                            deleteUrl={deleteGeneralRiskStatusesUrl}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('generalRiskFramework')) {
    var root = document.getElementById('generalRiskFramework');
    ReactDOM.render(
        <App>
            <GeneralRiskFramework />
        </App>,
        root,
    );
}
